import React, { createContext, useState, useContext } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setLoggedIn] = useState(false);

  // You would replace this with real login/logout logic
  const logIn = () => {
    setLoggedIn(true);
    console.log('LoggedIn')
  };

  const logOut = () => {
    setLoggedIn(false);
    console.log('LoggedOut')
  };

  return (
    <AuthContext.Provider value={{ isLoggedIn, logIn, logOut }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
